import { getAuthFromLocalStorage } from '@vcd-ecm-ui/LoginGatekeeper';
import UserRepo from './User/UserRepo';
import FetchWrapper from './Common/Wrappers/FetchWrapper';
import CertificateRepo from './Certificate/CertificateRepo';
import CustomerRepo from './Customer/CustomerRepo';
import BulkUploadRepo from './BulkUpload/BulkUploadRepo';
import SettingsRepo from './Settings/SettingsRepo';
import CorrespondenceRepo from './Correspondence/CorrespondenceRepo';
import ReportRepo from './Report/ReportRepo';
import ECWizardRepo from './ECWizard/ECWizardRepo';

export default class API {
    user: UserRepo;

    certificate: CertificateRepo;

    customer: CustomerRepo;

    bulkupload: BulkUploadRepo;

    settings: SettingsRepo;

    correspondence: CorrespondenceRepo;

    report: ReportRepo;

    ecwizard: ECWizardRepo;

    constructor(gatewayEndPoint: string) {
      const localStorageValue = getAuthFromLocalStorage();

      if (localStorageValue) {
        const { accessToken } = localStorageValue;
        const fetchWrapper = new FetchWrapper(gatewayEndPoint, accessToken);

        this.user = new UserRepo(fetchWrapper);
        this.certificate = new CertificateRepo(fetchWrapper);
        this.customer = new CustomerRepo(fetchWrapper);
        this.bulkupload = new BulkUploadRepo(fetchWrapper);
        this.settings = new SettingsRepo(fetchWrapper);
        this.correspondence = new CorrespondenceRepo(fetchWrapper);
        this.report = new ReportRepo(fetchWrapper);
        this.ecwizard = new ECWizardRepo(fetchWrapper);
      }
    }
}
